
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-checkout",
      function () {
        return require("private-next-pages/corporate-checkout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-checkout"])
      });
    }
  